const state = {
  id: null,
  options: {},
  publication_edition_id: undefined,
  publication_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'options.deadlines.artwork' },
  { key: 'options.deadlines.booking' },
  { key: 'options.deadlines.ofi' },
  { key: 'publication_edition_id' },
  { key: 'publication_id' },
  { key: 'title' },
]

export default state
